const index = {
    state: {
        ad_groups: [],
        selected_ad_group: {},
        show_new_ad_group_modal: false,
        reload_ad_group_list: false
    },

    getters: {
        ad_groups: (state) => {
            return state.ad_groups;
        },
        selected_ad_group: (state) => {
            return state.selected_ad_group;
        },
        show_new_ad_group_modal: (state) => {
            return state.show_new_ad_group_modal;
        },
        reload_ad_group_list:() => {
            return state.reload_ad_group_list;
        }
    },

    mutations: {
        set_ad_groups(state, payload) {
            state.ad_groups = payload;
            if (state.ad_groups.length > 0) {
                state.selected_ad_group = state.ad_groups[0];
            }
        },
        set_reload_ad_group_list(state, status){
            state.reload_ad_group_list = status; 
        },
        set_show_new_ad_group_modal(state, status){
            state.show_new_ad_group_modal = status; 
        },
        set_selected_ad_group(state, payload) {
            state.selected_ad_group = payload;
            /*state.selected_ad_group = payload;
            state.selected_ad_group.instances.forEach((instance, idx) => {
                let date_diff_indays = function(date1, date2) {
                    let dt1 = new Date(date1.replace(/-/g, '\/'));
                    let dt2 = new Date(date2.replace(/-/g, '\/'));
                    return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
                };
                if (!instance.duration) {
                    if (idx == 0) {
                        instance.duration = date_diff_indays(state.selected_ad_group.start_date, instance.end_date);
                    } else {
                        instance.duration = date_diff_indays(state.selected_ad_group.instances[idx - 1].end_date, instance.end_date);
                    }
                }
            })*/
        }
    },
    actions: {}
}

export default index;

